import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    Accept: 'application/json',
    // 'Content-Type': 'multipart/form-data',
  },
});

export default api;
